<div
  *ngIf="root && !app.isIcons()"
  class="item-title"
  [class.hidden]="root && (app.isStatic() || app.isOverlay())"
>
  @if (item.localeLabel) {
    <span class="layout-menuitem-text">
      {{ item.localeLabel | propertyTranslator }}
    </span>
  } @else {
    <span class="layout-menuitem-text">{{ item.label | translate }}</span>
  }
</div>

<ng-container
  *ngIf="item.routerLink && !item.items?.length"
  [ngTemplateOutlet]="itemWithRouterLink"
/>

<ng-container
  *ngIf="!item.routerLink || item.items?.length > 0"
  [ngTemplateOutlet]="itemWithSubItems"
/>

<ng-container *ngIf="item.items?.length" [ngTemplateOutlet]="subItems" />

<ng-template #itemWithSubItems>
  <span></span>
  <a
    role="link"
    (click)="itemClick($event)"
    (keydown.enter)="itemClick($event)"
    [attr.target]="item.target"
    [attr.tabindex]="0"
    [ngClass]="item.styleClass"
    [ngClass]="{
      '!px-1': !item.icon,
      'active-menuitem': hasActiveItem && app.isIcons(),
      'active-menuitem-routerlink': hasActiveItem,
    }"
    (mouseenter)="onMouseEnter($event)"
    pRipple
    [pTooltip]="item.label | translate"
    [tooltipDisabled]="
      isActiveItem || !(root && app.isSlim() && !app.isMobile())
    "
    [attr.data-testid]="item.id"
  >
    <i
      *ngIf="item.icon; else iconTpl"
      [ngClass]="[item.icon, item.iconClass ?? '']"
      class="layout-menuitem-icon"
      aria-hidden="true"
    ></i>

    <ng-container [ngTemplateOutlet]="label" />
    <span
      class="p-badge p-component p-badge-no-gutter"
      *ngIf="item.badge && !root"
      >{{ item.badge }}</span
    >
    <i
      class="pi pi-fw pi-angle-down layout-submenu-toggler"
      *ngIf="item.items?.length"
      aria-hidden="true"
    ></i>
  </a>
</ng-template>

<ng-template #itemWithRouterLink>
  <span></span>
  <a
    *ngIf="item.type === 'internal'; else externalLink"
    [routerLink]="item.routerLink"
    [routerLinkActive]="
      app.isIcons() ? 'active-menuitem' : 'active-menuitem-routerlink'
    "
    [routerLinkActiveOptions]="item.routerLinkActiveOptions ?? { exact: false }"
    [queryParams]="item.queryParams ? item.queryParams : {}"
    [attr.target]="item.target"
    [attr.tabindex]="0"
    class="{{ (isActiveItem && item.iconClass) || '' }}"
    [ngClass]="item.styleClass"
    [ngClass]="{
      '!px-1': !item.icon,
      'related-item': item.isRelatedItem,
      'has-related-item': item.hasRelatedItems,
      'last-related-item': item.isLastRelatedItem,
    }"
    (mouseenter)="onMouseEnter($event)"
    pRipple
    [pTooltip]="item.label | translate"
    [tooltipDisabled]="
      isActiveItem || !(root && app.isSlim() && !app.isMobile())
    "
    [attr.data-testid]="item.id"
    role="link"
  >
    <span
      class="layout-menuitem-icon"
      [ngClass]="{ 'related-item': item.isRelatedItem || item.hasRelatedItems }"
    >
      <i
        *ngIf="item.icon; else iconTpl"
        [ngClass]="[item.icon, item.iconClass ?? '']"
        aria-hidden="true"
      >
      </i>
      <span
        *ngIf="!!item.iconBadge"
        [class]="item.iconBadge.icon"
        [style.background-color]="item.iconBadge.color"
        class="p-badge p-component related-item__icon"
      ></span>
    </span>
    <ng-container [ngTemplateOutlet]="label" />
    <span
      class="p-badge p-badge-details p-component p-badge-no-gutter"
      *ngIf="item.badge && !root"
      >{{ item.badge }}</span
    >
    <span *ngIf="item.count !== undefined">({{ item.count }})</span>
    <i
      class="pi pi-fw pi-angle-down layout-submenu-toggler"
      *ngIf="item.items?.length"
      aria-hidden="true"
    ></i>
  </a>
</ng-template>

<ng-template #subItems>
  <ul
    #subitemsList
    [@children]="itemsExpanded ? 'visibleAnimated' : 'hiddenAnimated'"
    [class.fixed]="fixed && !isStatic && !isOverlay"
    role="list"
  >
    <ng-container *ngIf="itemsExpanded || item.preloadItems">
      <li
        menu-item
        *ngFor="let child of item.items; index as i; trackBy: trackByFn"
        [root]="false"
        [fixed]="fixed"
        [item]="child"
        [index]="i"
        [parentKey]="key"
        role="listitem"
      ></li>
    </ng-container>
  </ul>
</ng-template>
<ng-template #iconTpl>
  <i class="layout-menuitem-icon pi" aria-hidden="true">&nbsp;</i>
</ng-template>
<ng-template #externalLink>
  <a
    [href]="item.routerLink"
    [routerLinkActive]="
      app.isIcons() ? 'active-menuitem' : 'active-menuitem-routerlink'
    "
    [attr.target]="item.target"
    [attr.tabindex]="0"
    class="{{ (isActiveItem && item.iconClass) || '' }}"
    [ngClass]="item.styleClass"
    [ngClass]="{
      '!px-1': !item.icon,
    }"
    (mouseenter)="onMouseEnter($event)"
    pRipple
    [pTooltip]="item.label | translate"
    [tooltipDisabled]="
      isActiveItem || !(root && app.isSlim() && !app.isMobile())
    "
    [attr.data-testid]="item.id"
    role="link"
  >
    <span class="layout-menuitem-icon">
      <i
        *ngIf="item.icon; else iconTpl"
        [ngClass]="[item.icon, item.iconClass ?? '']"
        aria-hidden="true"
      >
      </i>
      <span
        *ngIf="!!item.iconBadge"
        [class]="item.iconBadge.icon"
        [style.background-color]="item.iconBadge.color"
        class="p-badge p-component related-item__icon"
      ></span>
    </span>
    <ng-container [ngTemplateOutlet]="label" />
    <span
      class="p-badge p-badge-details p-component p-badge-no-gutter"
      *ngIf="item.badge && !root"
      >{{ item.badge }}</span
    >
    <span *ngIf="item.count !== undefined">({{ item.count }})</span>
    <i
      class="pi pi-fw pi-angle-down layout-submenu-toggler"
      *ngIf="item.items?.length"
      aria-hidden="true"
    ></i>
  </a>
</ng-template>

<ng-template #label>
  <span class="flex">
    @if (item.localeLabel; as localeLabel) {
      <span
        class="layout-menuitem-text line-clamp"
        [class.layout-menuitem-text--tooltip]="
          item.description | propertyTranslator
        "
        pTooltip="{{ localeLabel | propertyTranslator }}"
        [showDelay]="1000"
        tooltipPosition="top"
      >
        {{ localeLabel | propertyTranslator }}
      </span>
    } @else {
      <span
        class="layout-menuitem-text line-clamp"
        [class.layout-menuitem-text--tooltip]="
          item.description | propertyTranslator
        "
        pTooltip="{{ item.label | translate }}"
        [showDelay]="1000"
        tooltipPosition="top"
      >
        {{ item.label | translate }}
      </span>
    }

    <ng-container [ngTemplateOutlet]="descriptionTooltip" />
  </span>
</ng-template>

<ng-template #descriptionTooltip>
  <app-value-based-tooltip
    focusable
    [dataSource]="item"
    propertyKey="description"
  />
</ng-template>
